export default "__VITE_ASSET__wka3A4Uw__"